import styled from "styled-components";
import {
	COLOR_HYPERLINK,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	FONT_WT_MEDIUM,
	COLOR_BORDER_GREY,
} from "@website-builder/utilities-index";

export const PanelWrapper = styled.div`
	border-top: 0.1px solid ${COLOR_BORDER_GREY};
	&:last-child {
		border-bottom: 0.1px solid ${COLOR_BORDER_GREY};
	}
	.header {
		user-select: none;
		line-height: 1.5;
		font-size: 18px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		padding: 1.2rem 0;
		margin: 0;
		cursor: pointer;
		display: flex;
		span.headerText {
			padding-left: 20px;
		}
		img.icon {
			vertical-align: middle;
		}
	}

	.detail {
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 27px;
		text-align: left;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-bottom: 10px;
		padding: 0 0 0 36px;
		display: ${(props) => (props.isActive ? "block" : "none")};
		a {
			color: ${COLOR_HYPERLINK};
		}
		p,
		ol,
		ul {
			margin: 0 0 10px;
		}
	}
`;
